import { useMutation } from "react-query";
import axios from "libs/axios";
import { MutationConfig } from "libs/react-query";
import { status, statusDetail } from "interface";
interface otpRequest {
  id: number;
  phoneNumber: string;
  code: string;
}
interface otpResponse {
  data: {
    id: string;
    phoneNumber: string;
    roles: string;
    jwToken: string;
    status: status;
    statusDetail: statusDetail;
  };
  isSuccess: true;
  message: string;
  statusCode: number;
}
const otp = async ({ data }: { data: otpRequest }) => {
  return await axios.post<otpResponse>("/api/Account/verify-token", data);
};
type otpOptions = {
  config?: MutationConfig<typeof otp>;
};
export const useOtp = ({ config }: otpOptions) => {
  return useMutation({
    ...config,
    mutationFn: otp,
  });
};
